<template>
  <div v-if="!shouldHide">
    <slot></slot>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    computed: {
      ...mapState('users', ['currentUser']),

      shouldHide() {
        return this.currentUser.role === 'SECURITY';
      },
    },
  };
</script>

<style scoped>
  /* Styles for the wrapper */
</style>
